import { engageLabCore } from '@jg/qiankun-micro-tool';

export function getOrgId() {
  return engageLabCore.organization.takeImmediately().id as string;
}
export function getLan() {
  return engageLabCore.locale.takeImmediately();
}
export function go(path: string, str = '') {
  if (path.includes('push')) {
    path = path.split('push').join('-push');
  }
  if (path === 'ma') {
    path = 'marketing-automation';
  }
  if (path === 'silentauth') {
    path = 'silent-auth';
  }
  location.href = `/console/${path}/#/${path}/${getOrgId() + str}`;
}
export function mainGo(str = '') {
  location.href = `/console/#/console/${getOrgId() + str}`;
}
export function getOrgIdPath(path = '') {
  return '/o-' + getOrgId() + '/' + path;
}
export function arrToObj<T>(arr: T[], key: string) {
  const obj: { [k: string]: T } = {};
  arr.forEach(o => {
    obj[(o as any)[key]] = o;
  });
  return obj;
}

export function exportData(data: any, name: string) {
  const blob = new Blob([data]);

  downFile(URL.createObjectURL(blob), name);
}
export function downFile(url: string, name: string, suffix = '.xlsx') {
  const a = document.createElement('a');
  a.setAttribute('href', url);
  a.setAttribute('target', '_blank');
  a.setAttribute('download', name + suffix);
  a.click();
}

export function searchObj(searchStr = '') {
  const obj: { [key: string]: string } = {};
  const str = (searchStr || location.search || '?').slice(1).split('&');
  str.forEach(s => {
    const arr = s.split('=');
    if (arr.length === 2) {
      obj[arr[0]] = arr[1];
    }
  });
  return obj;
}
export function hashObj(hashStr = '') {
  const obj: { [key: string]: string } = {};
  const str = (hashStr || location.hash).split('?');
  if (str.length === 2) {
    str[1].split('&').forEach(s => {
      const arr = s.split('=');
      if (arr.length === 2) {
        obj[arr[0]] = arr[1];
      }
    });
  }
  return obj;
}
export function pageLan<T>(
  zh_CN: T,
  zh_TW?: T,
  en_US?: T,
  ja_JP?: T,
  th_TH?: T,
  es_ES?: T,
  id_ID?: T,
) {
  return (
    {
      zh_TW,
      en_US,
      ja_JP,
      th_TH,
      zh_CN,
      es_ES,
      id_ID,
    }[getLan() as 'zh_CN'] || zh_CN
  );
}

const sideCodes: Record<string, boolean> = {};
let sideData: any = { permissionCodes: {} };
let hasSide = false;
export function hasSideData() {
  return hasSide;
}
export function setSideData(data?: any) {
  hasSide = true;
  sideData = data || { permissionCodes: {} };
  if (sideData) {
    const list = sideData.permissionCodes.codes || [];
    list.forEach((code: string) => {
      sideCodes[code] = true;
    });
  }
}
function isAdmin() {
  const per = sideData.permissionCodes;
  return !!(per.isOrgOwner || per.isOrgAdmin);
}
//根据code判断是否有权限
export function hasCode(code: string) {
  if (isAdmin()) {
    return true;
  }
  return !!sideCodes[code];
}
export const filterOption = (input: string, option: any) => {
  return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
};
//保留两位小数，并做大于小位数时做进位处理
export function setNum(n = 0) {
  n = n || 0;
  const t = Number.parseFloat(n.toFixed(2));
  const t2 = Number.parseFloat(n.toFixed(6));
  n = t2 > t ? t + 0.01 : t;
  return n
    .toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
    })
    .slice(1);
}
export function toPercent(n = 0) {
  n *= 100;
  let str = n.toFixed(2);
  while (str.endsWith('0')) str = str.substring(0, str.length - 1);
  if (str.endsWith('.')) str = str.substring(0, str.length - 1);
  return str + '%';
}
export function addSymbol(n: number | string, isZero = false) {
  const t = Number.parseFloat((n || 0) + '');
  let text = setNum(t);
  text = text.startsWith('$') ? text.replace('$', '$ ') : '$ ' + text;
  return !isZero && !t ? '--' : text;
}
export function addClue(business: string) {
  //'SMS' | 'Email' | 'WebPush' | 'AppPush'
  return {
    firstVisitUrl: sessionStorage.getItem('first_visit_url') || location.href,
    addFrom: 'EngageLab-' + business,
    subChannel: 'portal_website',
    submissionUrl: location.href,
    mainChannel: 'engagelab_nature',
    refererUrl: sessionStorage.getItem('first_referer_url'),
  };
}

export function splitText(text: string) {
  const segments = text.split(/\s*\$\{[^}]+\}\s*/);
  const cleanedSegments = segments.map(segment => segment.trim());
  return cleanedSegments;
}

export function businessText(business: string) {
  return business === 'NEWSMS' ? 'SMS' : business;
}
